// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /search/teams-players.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeSearchTeamsPlayersBody,
  typeSearchTeamsPlayersOutput200,
} from "../../sdk/search/postSearchTeamsPlayers";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildSearchTeamsPlayersQueryKey(
  payload: typeSearchTeamsPlayersBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`query:${JSON.stringify(payload.query)}`);
  return [
    "post:search:searchTeamsPlayers",
    "svc:sports-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeSearchTeamsPlayersOutput200,
    unknown,
    typeSearchTeamsPlayersOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useSearchTeamsPlayers(
  payload: typeSearchTeamsPlayersBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildSearchTeamsPlayersQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postSearchTeamsPlayers(payload),
    ...resolvedOptions,
  });
}
